import React, { useState } from 'react';
import {
  Box,
  Button,
  Flex,
  Icon,
  Text,
  Wrap,
  WrapItem,
  useColorModeValue,
} from '@chakra-ui/react';
import { observer } from 'mobx-react';
import { MdDownload } from 'react-icons/md';
import { PLATFORMS, PLATFORM_ORDER } from '../data/platforms/index';

const DownloadPanel = observer(({ store }) => {
  const [isDownloadingAll, setIsDownloadingAll] = useState(false);
  const [downloadingPlatform, setDownloadingPlatform] = useState(null);
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const bgCard = useColorModeValue('gray.50', 'gray.800');
  const mutedColor = useColorModeValue('gray.500', 'gray.400');

  const handleDownloadAll = async () => {
    setIsDownloadingAll(true);
    try {
      await store.downloadAll();
    } finally {
      setIsDownloadingAll(false);
    }
  };

  const handleDownloadPlatform = async (platformId) => {
    setDownloadingPlatform(platformId);
    try {
      await store.downloadPlatform(platformId);
    } finally {
      setDownloadingPlatform(null);
    }
  };

  const activePlatforms = PLATFORM_ORDER.filter((id) =>
    store.generatedIcons.some((i) => i.platformId === id)
  );

  return (
    <Box p={4} borderRadius="xl" borderWidth="1px" borderColor={borderColor} bg={bgCard}>
      <Flex justify="space-between" align="center" mb={4}>
        <Box>
          <Text fontWeight="semibold" fontSize="sm">Download</Text>
          <Text fontSize="xs" color={mutedColor} mt={0.5}>
            {store.generatedIcons.length} icons across {activePlatforms.length} platform{activePlatforms.length !== 1 ? 's' : ''}
          </Text>
        </Box>
        <Button
          colorScheme="blue"
          size="md"
          leftIcon={<Icon as={MdDownload} />}
          onClick={handleDownloadAll}
          isLoading={isDownloadingAll}
          loadingText="Zipping…"
          borderRadius="lg"
          fontWeight="semibold"
        >
          Download All ZIP
        </Button>
      </Flex>

      {activePlatforms.length > 1 && (
        <Box>
          <Text fontSize="xs" color={mutedColor} mb={2} textTransform="uppercase" letterSpacing="wide" fontWeight="semibold">
            Per platform
          </Text>
          <Wrap spacing={2}>
            {activePlatforms.map((id) => {
              const platform = PLATFORMS[id];
              const count = store.generatedIcons.filter((i) => i.platformId === id).length;
              return (
                <WrapItem key={id}>
                  <Button
                    size="sm"
                    variant="outline"
                    colorScheme={platform.colorScheme}
                    leftIcon={<MdDownload />}
                    borderRadius="lg"
                    onClick={() => handleDownloadPlatform(id)}
                    isLoading={downloadingPlatform === id}
                    loadingText="Zipping…"
                  >
                    {platform.emoji} {platform.label}
                    <Text as="span" ml={1.5} fontSize="xs" opacity={0.7}>
                      ({count})
                    </Text>
                  </Button>
                </WrapItem>
              );
            })}
          </Wrap>
        </Box>
      )}
    </Box>
  );
});

export default DownloadPanel;
